import React, { useState, useEffect } from 'react';
import axios from 'axios';
import * as XLSX from 'xlsx';
import regresaBienFecha from '../tools/regresaBienFecha';
import InfoCadete from '../tools/InfoCadete';
import ObtieneDatosCookies from "../tools/obtieneDatosCookiesUsuario";
import Swal from 'sweetalert2';
import AvisosInternosPorFecha from '../NCadetes/AvisosInternosPorFecha';

const GuardiaComponentFecha = ({ sede, fecha }) => {
  const [esValida, setEsValida] = useState(false);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [veoCadetesPresentesTotales, setVeoCadetesPresentesTotales] = useState(true);
  const Usuario = ObtieneDatosCookies();

  const traeGuardiaHoy = async () => {
    try {
      const response = await axios.post(
        `https://wwwa.isepsantafe.net.ar/expedientes/NCadetes/devuelveGuardiaFecha`,
        { fecha: fecha, sede: sede }
      );
//       console.log(response);
      setData(response.data);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    traeGuardiaHoy();
    const esHoyOAnterior = (fechaString) => {
      const opciones = { timeZone: 'America/Argentina/Buenos_Aires' };
      const fechaIngresada = new Date(fechaString + 'T00:00:00-03:00');
      const hoy = new Date().toLocaleString('en-US', opciones);
      const fechaHoy = new Date(hoy);

      fechaIngresada.setHours(0, 0, 0, 0);
      fechaHoy.setHours(0, 0, 0, 0);

      return fechaIngresada <= fechaHoy;
    };

    setEsValida(esHoyOAnterior(fecha));
  }, [fecha]);

  const obtenerAnio = (promocion) => {
    return promocion === '2026-2027' ? 'Primer Año' : 'Segundo Año';
  };

  const agruparPorPromocion = (cadetes) => {
    return cadetes?.reduce((grupo, cadete) => {
      const promocion = cadete?.cadete?.Promocions?.[0]?.nombre || 'Sin promoción';
      if (!grupo[promocion]) {
        grupo[promocion] = [];
      }
      grupo[promocion].push(cadete);
      return grupo;
    }, {}) || {};
  };

  const exportarExcel = () => {
    const ws = XLSX.utils.json_to_sheet(
      data.GrupoCadetesGuardia.map((cadete) => ({
        DNI: cadete?.cadeteDni || 'Sin DNI',
        Apellido: cadete?.cadete?.cadeteApellido || 'Sin apellido',
        Nombre: cadete?.cadete?.cadeteNombre || 'Sin nombre',
        Promoción: cadete?.cadete?.Promocions?.[0]?.nombre || 'Sin promoción',
        tipo: cadete?.tipo || ''
      }))
    );

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Guardia');
    XLSX.writeFile(wb, 'GuardiaCadetes.xlsx');
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  const cadetesPorPromocion = agruparPorPromocion(data?.GrupoCadetesGuardia);
  const cadetesAusentes = agruparPorPromocion(data?.cadetesAusentes);

  const esFechaFutura = (fechaGuardia) => {
    const fechaGuardiaDate = new Date(fechaGuardia);
  
    // Crear fecha actual en Buenos Aires (GMT-3)
    const ahora = new Date();
    const fechaBuenosAires = new Date(
      ahora.getUTCFullYear(),
      ahora.getUTCMonth(),
      ahora.getUTCDate(),
      ahora.getUTCHours() - 6,
      ahora.getUTCMinutes(),
      ahora.getUTCSeconds()
    );
 
    return fechaGuardiaDate >= fechaBuenosAires;
  };
  

  
  const ordenarPorApellido = (cadetes) => {
    return cadetes?.sort((a, b) => {
      const apellidoA = a?.cadete?.cadeteApellido?.toUpperCase() || '';
      const apellidoB = b?.cadete?.cadeteApellido?.toUpperCase() || '';
      return apellidoA.localeCompare(apellidoB);
    }) || [];
  };

  
  const anularGuardia = async (cadeteId, destinoUsuario) => {
    
    if (destinoUsuario != Usuario.dependenciaNombre&&Usuario.destino!=7) {
  
      Swal.fire('No puedes anular esta guardia', 'El destino donde fue cargado no coincide con tu destino actual', 'error');
      return;
    }

   
    const result = await Swal.fire({
      title: '¿Estás seguro de anular esta guardia?',
      text: 'Esta acción no se puede deshacer.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#dc3545',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Sí, anular',
      cancelButtonText: 'Cancelar'
    });

    if (result.isConfirmed) {
      try {
        await axios.post(
          `https://wwwa.isepsantafe.net.ar/expedientes/NCadetes/anularGuardiaPorId`,
          {
            id: cadeteId,
            userID: Usuario.identificacion
          }
        );
        await traeGuardiaHoy(); 
        Swal.fire('Guardia anulada', 'La guardia ha sido anulada exitosamente', 'success');
      } catch (error) {
        console.error('Error al anular guardia:', error);
        Swal.fire('Error', 'Hubo un problema al anular la guardia', 'error');
      }
    }
  };

  return (
    <div style={{ display: 'flex', width: '100%', flexDirection: 'column', alignItems: 'center' }}>
      
      <h2 style={{ width: '100%', background: 'GrayText', borderRadius: '15px', padding: '5px' }}>
        Información de Guardia e Internos del {regresaBienFecha(fecha)}
      </h2>
     
      <AvisosInternosPorFecha fecha={fecha} sede={sede} />
      {data && (
        <div style={{ width: '90%' }}>
          <h3 style={{ color: 'white', background: '#489' }}>Sede: {data.sede}</h3>
          <p>Total de cadetes del grupo de guardia (Recargados y Ordinaria): {data.totalCadetesGuardia}</p>

          <div>
            <h4 onClick={() => setVeoCadetesPresentesTotales(!veoCadetesPresentesTotales)}>
              Cadetes programados para la guardia {veoCadetesPresentesTotales ? '-' : '+'}
            </h4>
            {veoCadetesPresentesTotales ? (
              <div>
                {Object.entries(cadetesPorPromocion).map(([promocion, cadetes]) => (
                  <div key={promocion}>
                    <h5 style={{ color: '#fff', background: '#4b8' }}>
                      Promoción: {promocion} ({obtenerAnio(promocion)})
                    </h5>
                    <ul>
                      {ordenarPorApellido(cadetes).map((cadete, index) => (
                        <li
                          key={cadete?.cadeteDni || Math.random()}
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            padding: '4px',
                            borderBottom: '1px solid #ccc'
                          }}
                        >
                          <span onClick={() => InfoCadete(cadete?.cadeteDni)} style={{ cursor: 'pointer' }}>
                            {index + 1}. {cadete?.cadete?.cadeteApellido || 'Sin apellido'}{' '}
                            {cadete?.cadete?.cadeteNombre || 'Sin nombre'} - {cadete?.cadeteDni || 'Sin DNI'} -{' '}
                            <strong>{cadete.tipo}</strong>
                          </span>
                          {cadete.estado == 'Activa' && esFechaFutura(fecha) && (
                            <button
                              onClick={async () => {
                                await anularGuardia(cadete.id, cadete.destinoUsuario); 
                              }}
                              style={{
                                backgroundColor: '#dc3545',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                padding: '4px 8px',
                                cursor: 'pointer'
                              }}
                            >
                              Anular
                            </button>
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}<button
                onClick={exportarExcel}
                style={{
                  marginBottom: '20px',
                  padding: '10px',
                  background: '#28a745',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer'
                }}
              >
                Exportar guardia a Excel
              </button>
              </div>
            ) : (
              ''
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default GuardiaComponentFecha;
